import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import Layout from './components/Layout';
import GlobalSnackbar from './components/GlobalSnackbar';
import { isAuthenticated } from './api';
import Login from './pages/Login';
import Home from './pages/Home';
import ProjectList from './pages/ProjectList';
import WorkerList from './pages/WorkerList';
import WorkLogList from './pages/WorkLogList';
import MaterialList from './pages/MaterialList';
import ExpenseList from './pages/ExpenseList';
import IncomeList from './pages/IncomeList';
import QuotationList from './pages/QuotationList';
import QuotationDetail from './pages/QuotationDetail';
import QuotaLibrary from './pages/QuotaLibrary';
import SalaryReport from './pages/SalaryReport';
import WorkerStatement, { WorkerStatementWithParams } from './pages/WorkerStatement';
import ProfitReport from './pages/ProfitReport';
import QuotationMarginReport from './pages/QuotationMarginReport';
import DataImport from './pages/DataImport';
import AdjustmentList from './pages/AdjustmentList';
import ContactList from './pages/ContactList';
import Settings from './pages/Settings';
import AiSettings from './pages/AiSettings';
import NotFound from './pages/NotFound';

// 路由守卫：未登录跳 /login
function RequireAuth({ children }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* 登录页不需要认证 */}
          <Route path="/login" element={<Login />} />

          {/* 其他所有页面都需要登录 */}
          <Route path="/*" element={
            <RequireAuth>
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/projects" element={<ProjectList />} />
                  <Route path="/workers" element={<WorkerList />} />
                  <Route path="/work-logs" element={<WorkLogList />} />
                  <Route path="/materials" element={<MaterialList />} />
                  <Route path="/expenses" element={<ExpenseList />} />
                  <Route path="/incomes" element={<IncomeList />} />
                  <Route path="/quotations" element={<QuotationList />} />
                  <Route path="/quotations/new" element={<QuotationDetail />} />
                  <Route path="/quotations/:id" element={<QuotationDetail />} />
                  <Route path="/quotation-margin" element={<QuotationMarginReport />} />
                  <Route path="/quota-library" element={<QuotaLibrary />} />
                  <Route path="/salary" element={<SalaryReport />} />
                  <Route path="/workers/:workerId/statement/:month" element={<WorkerStatementWithParams />} />
                  <Route path="/profit" element={<ProfitReport />} />
                  <Route path="/data-import" element={<DataImport />} />
                  <Route path="/adjustments" element={<AdjustmentList />} />
                  <Route path="/contacts" element={<ContactList />} />
                  <Route path="/ai-settings" element={<AiSettings />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Layout>
            </RequireAuth>
          } />
        </Routes>
      </Router>
      <GlobalSnackbar />
    </ThemeProvider>
  );
}

export default App;
